"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateClientWithAmplifyInstance = generateClientWithAmplifyInstance;
const runtime_1 = require("@aws-amplify/data-schema/runtime");
const types_1 = require("../../types");
const isApiGraphQLProviderConfig_1 = require("../utils/runtimeTypeGuards/isApiGraphQLProviderConfig");
const __1 = require("..");
/**
 * @private
 *
 * Used internally by `adapter-nextjs` package.
 *
 * Creates a client that can be used to make GraphQL requests, using a provided `AmplifyClassV6`
 * compatible context object for config and auth fetching.
 *
 * @param params
 * @returns
 */
function generateClientWithAmplifyInstance(params) {
    const client = {
        [types_1.__amplify]: params.amplify,
        [types_1.__authMode]: params.authMode,
        [types_1.__authToken]: params.authToken,
        [types_1.__apiKey]: 'apiKey' in params ? params.apiKey : undefined,
        [types_1.__endpoint]: 'endpoint' in params ? params.endpoint : undefined,
        [types_1.__headers]: params.headers,
        graphql: __1.graphql,
        cancel: __1.cancel,
        isCancelError: __1.isCancelError,
    };
    const apiGraphqlConfig = params.config?.API?.GraphQL;
    if (client[types_1.__endpoint]) {
        if (!client[types_1.__authMode]) {
            throw new Error('generateClient() requires an explicit `authMode` when `endpoint` is provided.');
        }
        if (client[types_1.__authMode] === 'apiKey' && !client[types_1.__apiKey]) {
            throw new Error("generateClient() requires an explicit `apiKey` when `endpoint` is provided and `authMode = 'apiKey'`.");
        }
    }
    if (!client[types_1.__endpoint] && (0, isApiGraphQLProviderConfig_1.isApiGraphQLConfig)(apiGraphqlConfig)) {
        (0, runtime_1.addSchemaToClientWithInstance)(client, params, types_1.getInternals);
    }
    return client;
}
